export default "__VITE_ASSET__710ba745__"